import { createSlice,current } from '@reduxjs/toolkit';

const statusOption = ["Supplier"];
  const paymentMethod = [
    "Cash On Hand",
    "Allied Bank Account",
    "EasyPaisa Account",
  ];


const initialState = {
  purchaseOrder:[],
  statusOption,
  paymentMethod,
};

export const purchaseOrderSlice = createSlice({
  name: 'purchaseOrder',
  initialState,
  reducers: {
    setPurchaseOrder: (state, { payload }) => {
     
      state.purchaseOrder = [...payload];
    },
    
   
    clearPurchaseOrderState: (state) => {
      state=initialState
    }
  }
});

export const { setPurchaseOrder, clearPurchaseOrderState } = purchaseOrderSlice.actions;

export const purchaseOrderData = (state) => state.purchaseOrder;

export const getStatusOption = (state) => state.purchaseOrder.statusOption;
export const getPaymentMethod = (state) => state.purchaseOrder.paymentMethod;

export default purchaseOrderSlice.reducer;
